import type { PlatformId } from './PlatformIcon';

/** Every platform UniPostudio publishes to, in the order the UI lists them. */
export const PLATFORM_LIST: { id: PlatformId; label: string }[] = [
  { id: 'instagram', label: 'Instagram' },
  { id: 'facebook', label: 'Facebook' },
  { id: 'twitter', label: 'X (Twitter)' },
  { id: 'linkedin', label: 'LinkedIn' },
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'telegram', label: 'Telegram' },
  { id: 'youtube', label: 'YouTube' },
  { id: 'pinterest', label: 'Pinterest' },
  { id: 'tiktok', label: 'TikTok' },
  { id: 'google_business', label: 'Google Business' },
  { id: 'zetpin', label: 'Zetpin' },
];
